import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Schedule/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmLivestreamPerm';
import SheduleTable from 'components/Web_User_Interface/1440p_Series/Alarm/Schedule/scheduleTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü // Alarm Zeitplan",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/Zeitplan/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Legen Sie hier Ihren Zeitplan fest, an dem die Bewegungserkennung für die Bereiche aktiv sein soll. Jede blaue Box Symbolisiert dabei eine Aktivitätsphase von 30 Minuten. Bitte stellen Sie sicher, dass Sie die korrekte Zeitzone einstellen, die auch von Ihrer Kamera genutzt wird. Denken Sie an die Zeitumstellung!",
  "image": "./WebUI_1440p_SearchThumb_Alarm_Schedule.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm_Schedule.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Alarm Menü // Alarm Zeitplan' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Legen Sie hier Ihren Zeitplan fest, an dem die Bewegungserkennung für die Bereiche aktiv sein soll. Jede blaue Box Symbolisiert dabei eine Aktivitätsphase von 30 Minuten. Bitte stellen Sie sicher, dass Sie die korrekte Zeitzone einstellen, die auch von Ihrer Kamera genutzt wird. Denken Sie an die Zeitumstellung!' image='/images/Search/WebUI_1440p_SearchThumb_Alarm_Schedule.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm_Schedule.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Schedule/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Schedule/' crumbLabel="Alarm Schedule" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-men%C3%BC",
        "aria-label": "alarm menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "automatisieren-sie-die-alarmfunktion",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#automatisieren-sie-die-alarmfunktion",
        "aria-label": "automatisieren sie die alarmfunktion permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Automatisieren Sie die Alarmfunktion`}</h3>
    <p>{`Hier können Sie einen Zeitplan festlegen, in der die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
      }}>{`Bewegungserkennung`}</a>{` für die `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Bereiche/"
      }}>{`Alarmbereiche`}</a>{` aktiviert sein soll. Jedes orange Quadrat steht für 30 Minuten aktivierter Bewegungserkennung. Bitte stellen Sie sicher, dass die richtige `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/System/Datum_Uhrzeit/"
      }}>{`Zeitzone`}</a>{` eingestellt ist, da diese dazu von der Kamera verwendet wird.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/80f8b6de4fd5db1acfb528eecf30c998/e2e58/1440p_Settings_Alarm_Schedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAChElEQVQoz1WRS08TURhA+RnEZ0lMpJSViVYTBRbQVtrO487cmc5MW0opUB4WETotVVFMlIe4MNGAG0BkYYwLiQsiihLjypV/wN9yzBSiuDg5997FyZfvtnR2dhIOh+krPODmzDaxW6/oGV+nq7xG99g63WNH/nsvrzXPPWMvUfxtZGWF8+dO09raSigUoiUSiTSDqeGH2Hd38OZ3MOtbTfTqBqK2ifA3kHOv/1o2tnHuvSG38BZ1eJ7wxXbC4WCwCC0dHR3NYKK3h7FSHn96kvHhAUYGPUoDDiMFj+GCS7mYbTrvGIhUHKkl0VJ9JGNxNDVPPKYQvXLtaML29nYUVaVWbzBb9an6NfxjqlWfWq2OX6tTr88xOlpGFwLTlBjSxFRsnJtFUvEU165GjyYMgrFYDGlZqOkkmlvCnHuNWds4ZhMZuL6F3djCvb/TxL73hkEnx+qQTTHfT9eN6L8dJhIJ8vkBbCnIlKbJrn7HW/l6zDeyKwd4Tw/xlr/gLgdvB9hPPjNUKvH8UZGhXDdd16/+H/S8LKauIgencJa/4Szu4y59xl36gru0j7N80HRwD4La/C6NhUV+7m4y5cWJRq/822EQzGaz2JbE9gZwR30ypTsYhQpmYQqzUME4Yas4jV2a4e5cnd97e6xXRrh8+VIQPP7lRJyc5+I6GaRpINQ0Qkujq6kTKOiaiik0bKGiK2nmZ2/z6/ATm40JtN4TO4zFE2hWFsVwkHYGKS2EMP4jiAolieNmkPk8iuNSGRniw9ozFgYFMh6lpTMS4cLFMK7ay4+VNIdPkkzkVBTdwBACXdcRgVUF684LrMcfmSw/4l1/iveaRf+NLk6dOUtbqI1QqI0/6PLOG91xUx4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/80f8b6de4fd5db1acfb528eecf30c998/e4706/1440p_Settings_Alarm_Schedule.avif 230w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/d1af7/1440p_Settings_Alarm_Schedule.avif 460w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/7f308/1440p_Settings_Alarm_Schedule.avif 920w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/c986f/1440p_Settings_Alarm_Schedule.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/80f8b6de4fd5db1acfb528eecf30c998/a0b58/1440p_Settings_Alarm_Schedule.webp 230w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/bc10c/1440p_Settings_Alarm_Schedule.webp 460w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/966d8/1440p_Settings_Alarm_Schedule.webp 920w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/b8544/1440p_Settings_Alarm_Schedule.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/80f8b6de4fd5db1acfb528eecf30c998/81c8e/1440p_Settings_Alarm_Schedule.png 230w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/08a84/1440p_Settings_Alarm_Schedule.png 460w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/c0255/1440p_Settings_Alarm_Schedule.png 920w", "/de/static/80f8b6de4fd5db1acfb528eecf30c998/e2e58/1440p_Settings_Alarm_Schedule.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/80f8b6de4fd5db1acfb528eecf30c998/c0255/1440p_Settings_Alarm_Schedule.png",
              "alt": "Web User Interface - 1080p Series - Alarm Schedule",
              "title": "Web User Interface - 1080p Series - Alarm Schedule",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SheduleTable mdxType="SheduleTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h4 {...{
      "id": "zeitgesteuerte-bereicheinstellung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#zeitgesteuerte-bereicheinstellung",
        "aria-label": "zeitgesteuerte bereicheinstellung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zeitgesteuerte Bereicheinstellung`}</h4>
    <p>{`Aktivieren Sie diese Funktion, um die Bereiche 1&2 und 3&4 zu unterschiedlichen Zeiten zu aktivieren. Beispiele für die Anwendung sind:`}</p>
    <ul>
      <li parentName="ul">{`Nachts ist die Bewegungserkennung der Kamera oft um einiges empfindlicher. Zeichnen Sie für die Nacht Bereiche ein, die größer sind (um so größer der Bereich ist, desto unempfindlicher wird er, s. `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Bereiche/"
        }}>{`Alarm/Alarmbereiche`}</a>{`) und einen geringere Sensitivität eingestellt haben.`}</li>
      <li parentName="ul">{`Pan&Tilt Kameras können, über die `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Features/PTZ_Tour/"
        }}>{`PTZ Tour`}</a>{`, zu unterschiedlichen Zeiten an andere Positionen gefahren werden - z.B. kann man die Kamera tagsüber die Haustür überwachen lassen und sie nachts dann automatisch zum Carport schwenken lassen. Legen Sie entsprechend Bereiche 1&2 für die Tagpositione fest und die Bereiche 3&4 für die Nacht.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      